import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@/styles/app.css';
import { Providers } from '@/app/providers';
import { createAppRouter } from '@/app/router';
import { applyTheme, storedTheme } from '@hlt/web-kit/theme';
import { createQueryClient } from '@hlt/web-kit/api';
import { configureKit } from '@hlt/web-kit/config';
import { origins } from '@/app/origins';
import { createI18n, initialLocale } from '@hlt/web-kit/i18n';

// The platform serves its own links; tools are other origins sharing the same API session.
configureKit({
    serves: ['platform'],
    origins: { platform: window.location.origin, fiveS: origins.fiveS },
    siteOrigin: origins.site,
    apiOrigin: origins.api,
    inAppPath: (link) => link.path,
});

const queryClient = createQueryClient();
const locale = initialLocale();
applyTheme(storedTheme());
const router = createAppRouter(queryClient);
// The interface language is downloaded on its own; the first render waits for it.
const i18n = await createI18n(locale);

const root = document.getElementById('root');
if (root) {
    createRoot(root).render(
        <StrictMode>
            <Providers queryClient={queryClient} i18n={i18n}>
                <RouterProvider router={router} />
            </Providers>
        </StrictMode>,
    );
}
